import { render, staticRenderFns } from "./ModalConsignmentAddExecutor.vue?vue&type=template&id=f20b0ba6&"
import script from "./ModalConsignmentAddExecutor.vue?vue&type=script&lang=js&"
export * from "./ModalConsignmentAddExecutor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports